import React from "react";

export default function UAUCLoaderState({ loading, error, empty }) {
  if (loading) {
    return (
      <div className="rounded-3xl border border-slate-200 bg-slate-50 p-5">
        <div className="h-5 w-52 animate-pulse rounded bg-slate-200" />
        <div className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 6 }).map((_, index) => (
            <div
              key={index}
              className="h-28 animate-pulse rounded-2xl bg-slate-200/70"
            />
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="rounded-2xl border border-red-200 bg-red-50 p-5 text-sm font-bold text-red-700">
        {error}
      </div>
    );
  }

  if (empty) {
    return (
      <div className="rounded-3xl border border-dashed border-slate-300 bg-slate-50 p-8 text-center">
        <h4 className="text-base font-black text-slate-900">
          No unresolved observations found
        </h4>
        <p className="mt-2 text-sm font-medium text-slate-500">
          Try clearing filters or changing the selected assignee.
        </p>
      </div>
    );
  }

  return null;
}
